// Henri Dashboard page - chatbot analytics
// Shows conversation metrics and top questions


/**
 * NOTES SUMMARY - HENRI CHATBOX METRICS
 * 
 * What this page does:
 *  - Shows Henri chatbot metrics
 *  - Total conversations, conversions, conversion rate
 *  - Top 5 most asked questions
 *  - Refresh button reloads stats
 * 
 */



import React, { useState, useEffect } from 'react';
import Header from '../components/layout/Header';
import Sidebar from '../components/layout/Sidebar';
import ConversationStats from '../components/henri/ConversationStats';
import TopQuestions from '../components/henri/TopQuestions';
import { getHenriStats } from '../utils/api';
import '../styles/App.css';

function HenriDashboard() {
  // State for Henri stats
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Mobile menu state
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  
  const closeSidebar = () => {
    setSidebarOpen(false);
  };
  
  // Load stats when component mounts
  useEffect(() => {
    loadHenriStats();
  }, []);
  
  // Function to load Henri stats
  const loadHenriStats = async () => {
    setLoading(true);
    try {
      const data = await getHenriStats();
      setStats(data);
    } catch (error) {
      alert('Failed to load Henri stats: ' + error.message);
    } finally {
      setLoading(false);
    }
  };
  
  // Show loading state
  if (loading) {
    return (
      <div className="app-container">
        <Header onMenuClick={toggleSidebar} />
        <div className="app-body">
          <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
          <main className="app-main">
            <div className="loading">Loading Henri analytics...</div>
          </main>
        </div>
      </div>
    );
  }
  
  return (
    <div className="app-container">
      <Header onMenuClick={toggleSidebar} />
      <div className="app-body">
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
        <main className="app-main">
          <div className="page-header">
            <h1>Henri Analytics</h1>
            <button onClick={loadHenriStats} className="btn btn-secondary">
              Refresh Stats
            </button>
          </div>
          
          {/* KPI Cards Row */}
          <ConversationStats stats={stats} />
          
          {/* Top Questions Section */}
          <TopQuestions questions={stats?.topQuestions} />
        </main>
      </div>
    </div>
  );
}

export default HenriDashboard;